import { mui, React, ts } from '_core';

type QuantilesSelectorProps = {
  value: ts.types.widgets.common.BucketValue;

  setValue: (_v: ts.types.widgets.common.BucketValue) => void;
  disabled?: boolean;
  error?: boolean;
};

const QuantilesSelector = ({ value, setValue, disabled, error }: QuantilesSelectorProps) => {
  return (
    <mui.core.Grid size={{ xs: 12, md: 6 }}>
      <mui.core.TextField
        label="Quantiles (1 - 20)"
        variant="outlined"
        size="small"
        value={value.value}
        InputProps={{ inputProps: { min: 1, max: 20 } }}
        onChange={(e) => setValue({ ...value, value: e.target.value })}
        fullWidth
        required
        disabled={disabled}
        error={error}
      />
    </mui.core.Grid>
  );
};

export default QuantilesSelector;
